import { render, staticRenderFns } from "./ClearCartModal.vue?vue&type=template&id=de8c4fe4&"
import script from "./ClearCartModal.vue?vue&type=script&lang=js&"
export * from "./ClearCartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports